import { Component, OnInit } from '@angular/core';
import { SpinnerService } from './shared/services/spinner.service';

@Component({
  selector: 'pbg-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(public spinnerService: SpinnerService) {}
  ngOnInit(): void {
    console.log('Build Test 7 - 1323');
  }
}
